<template>
  <div>
    <div class="row">
      <div class="col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-xs-10 offset-xs-1 myContainer">
        <h1>METAVERSE JOB TITLES</h1>
        <br />
        <p class="text-black">
          MemeTeam.Fyi brings you your true calling. Mint a Job Title and find out what you should actually be doing in
          the metaverse. Are you the Chief Meme Officer? No, Ofc you aren't. You are probably a Junior Unhappiness Officer
          for Ooodles.
        </p>
        <p class="text-black">
          Each Job Title is a 1 of 1. There are a possible 11 Seniorties, 41 Job Titles, and 10 Companies resulting in
          4510 unique NFTs. Each Job Title confirms you as a CERTIFIED TOTAL DEGENERATE. Try your luck and mint one or
          more below, we don't care.
        </p>
        <p class="text-black">
          Job Titles are CC0, do with it what you want. What can you do with them? Nothing right now; We don't promise
          utility, we promise memes.
        </p>
      </div>
    </div>
    <div class="row vspace">
      <div class="col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-xs-10 offset-xs-1 myContainer">
        <h2>Minting</h2>
        <button class="btn btn-primary" v-if="! state" @click="connect">Connect</button>
        <div v-if="message">
          <span class="text-black">{{message}}</span>
        </div>
        <div v-if="state">
          <span class="text-black">Connected Account: {{address}}</span>
          <br />


          <form class="row g-3" v-if="! message">
            <div class="col-auto">
              <label for="mintNumber" class="visually-hidden">Number to mint</label>
              <input type="text" class="form-control" id="mintNumber" placeholder="5" v-model="number">
            </div>
            <div class="col-auto">
              <button class="btn btn-primary mb-3" :disabled="!chainCheck" @click="mint">Mint</button>
            </div>
          </form>

          <div class="alert alert-danger" role="alert" v-if="!chainCheck">
            Please make sure you are on the right chain (Target Id: {{targetChainId}}, {{chainId}})
          </div>
        </div>
        <br />
        <span class="text-black mintSpacer">{{supply}} / {{cap}} Minted</span>
      </div>
    </div>
    <div class="row vspace">
      <div class="col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-xs-10 offset-xs-1 myContainer">
        <h2>Important Links</h2>
         <a v-bind:href="getEtherscan" target="_blank" class="text-black">Etherscan</a><br />
         <a v-bind:href="getOpensea" target="_blank" class="text-black">Opensea</a><br />
         <a v-bind:href="getLooksRare" target="_blank" class="text-black">Looksrare</a><br />
          <router-link to="/jt-terms" class="text-black">Terms and Conditions</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import CoinbaseWalletSDK from '@coinbase/wallet-sdk';
const contractAddress = '0x737405F6dbb6Af87d0B65b192fCC136d60311647';
const contractAbi = [{"inputs":[{"internalType":"uint256","name":"cap","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"ApprovalCallerNotOwnerNorApproved","type":"error"},{"inputs":[],"name":"ApprovalQueryForNonexistentToken","type":"error"},{"inputs":[],"name":"ApproveToCaller","type":"error"},{"inputs":[],"name":"BalanceQueryForZeroAddress","type":"error"},{"inputs":[],"name":"MintERC2309QuantityExceedsLimit","type":"error"},{"inputs":[],"name":"MintToZeroAddress","type":"error"},{"inputs":[],"name":"MintZeroQuantity","type":"error"},{"inputs":[],"name":"OwnerQueryForNonexistentToken","type":"error"},{"inputs":[],"name":"OwnershipNotInitializedForExtraData","type":"error"},{"inputs":[],"name":"TransferCallerNotOwnerNorApproved","type":"error"},{"inputs":[],"name":"TransferFromIncorrectOwner","type":"error"},{"inputs":[],"name":"TransferToNonERC721ReceiverImplementer","type":"error"},{"inputs":[],"name":"TransferToZeroAddress","type":"error"},{"inputs":[],"name":"URIQueryForNonexistentToken","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"fromTokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"toTokenId","type":"uint256"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"ConsecutiveTransfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"GREED_CAP","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"SUPPLY_CAP","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseUri","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"quantity","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"saleStart","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"uri","type":"string"},{"internalType":"uint256","name":"startBlock","type":"uint256"}],"name":"setConfig","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}];
const targetChainId = 4;

export default {
  name: "JobTitleGeneratorMint",
  data() {
    return {
      web3: null,
      state: 0,
      address: null,
      chainId: null,
      contract: null,
      supply: 0,
      cap: 0,
      number: 0,
      targetChainId: targetChainId,
      message: null,
    };
  },
  computed: {
    getLooksRare() {
      return `https://rinkeby.looksrare.org/collections/${contractAddress}`;
    },
    getOpensea() {
      return `https://testnets.opensea.io/assets/rinkeby/${contractAddress}`;
    },
    getEtherscan() {
      return `https://rinkeby.etherscan.io/address/${contractAddress}`;
    },
  },
  methods: {
    async chainCheck() {
      return this.chainId === targetChainId
    },
    async mint(e) {
      e.preventDefault();
      let qty = parseInt(this.number);
      if (qty > 0) {
        let gas = this.contract.methods.mint(qty).estimateGas({
          from: this.address
        });

        let tx = this.contract.methods.mint(qty).send({
          from: this.address
        });

        this.state = 0;
      }
    },
    async connect() {
      const providerOptions = {
        /* See Provider Options Section */
        walletconnect: {
          package: WalletConnectProvider, // required
          options: {
            infuraId: process.env.INFURA_ID, // required
          }
        },
        coinbasewallet: {
          package: CoinbaseWalletSDK, // Required
          options: {
            appName: "CFA", // Required
            infuraId: process.env.INFURA_ID, // Required
            rpc: "", // Optional if `infuraId` is provided; otherwise it's required
            chainId: 1, // Optional. It defaults to 1 if not provided
            darkMode: false // Optional. Use dark theme, defaults to false
          }
        }
      };

      const web3Modal = new Web3Modal({
        network: "mainnet", // optional
        cacheProvider: true, // optional
        providerOptions, // required
        theme: {
          background: "rgb(0,0,23)",
          main: "rgb(199, 199, 199)",
          secondary: "rgb(136, 136, 136)",
          border: "rgba(197,156,108)",
          hover: "rgb(16, 26, 32)"
        }
      });

      const provider = await web3Modal.connect();

      this.web3 = new Web3(provider);

      let accounts = await this.web3.eth.getAccounts();

      this.address = accounts[0];
      this.chainId = parseInt(await this.web3.eth.getChainId());

      this.contract = new this.web3.eth.Contract(contractAbi, contractAddress);

      provider.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          this.address = accounts[0];
        } else {
          this.state = 0;
        }
      });

      provider.on("chainChanged", (chainId) => {
        this.chainId = chainId;
      });

      provider.on("disconnect", () => {
        this.state = 0;
      });

      let supply = await this.contract.methods.totalSupply().call();
      let cap = await this.contract.methods.SUPPLY_CAP().call();
      let saleStart = await this.contract.methods.saleStart().call();
      let bn = await this.web3.eth.getBlockNumber();
      this.supply = parseInt(supply);
      this.cap = parseInt(cap);

      if (supply < cap && bn > saleStart && parseInt(saleStart) > 0) {
        this.state = 1;

      } else {
        this.message = "Sale not active and/or we minted out";
        console.log(saleStart, supply, cap);
      }
    }
  }
}
</script>

<style lang="css">

</style>